import React from 'react';
import ModalDialog from '../components/Dialog/ModalDialog';
import ProductDetailContent, { ProductDetailProduct } from '../components/ProductDetailContent/ProductDetailContent';
import './ProductDetailDialog.css';

interface ProductDetailDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onBack?: () => void;
  product: ProductDetailProduct;
  onAddProduct?: (productId: number) => void;
}

const ProductDetailDialog: React.FC<ProductDetailDialogProps> = ({
  isOpen,
  onClose,
  onBack,
  product,
  onAddProduct,
}) => {
  const handleAddProduct = () => {
    onAddProduct?.(Number(product.product_id));
    onClose();
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Product Details"
      primaryButton={
        onAddProduct
          ? { label: 'Add Product', onClick: handleAddProduct }
          : undefined
      }
      secondaryButton={onBack ? { label: 'Back', onClick: onBack } : undefined}
      maxWidth="480px"
      maxHeight="90vh"
    >
      <div className="product-detail-dialog-body">
        <ProductDetailContent product={product} />
      </div>
    </ModalDialog>
  );
};

export default ProductDetailDialog;
